export default __webpack_public_path__ + "static/media/logo_caer.7b272a81.jpg";